module.exports = __webpack_public_path__ + "img/bg_7.1a857392.png";